var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { InternalProvider } from '../../util/InternalProvider';
import { getFontSize, getFontWeight, } from '../../abstracts/typography';
var TextElement = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.2;\n  ", "\n"], ["\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.2;\n  ", "\n"])), function (_a) {
    var fontSize = _a.fontSize;
    return getFontSize(fontSize);
}, function (_a) {
    var fontWeight = _a.fontWeight;
    return getFontWeight(fontWeight);
}, function (_a) {
    var color = _a.color;
    return (color ? "color: " + color + ";" : undefined);
});
export var Text = forwardRef(function (_a, fRef) {
    var _b = _a.size, size = _b === void 0 ? 2 : _b, _c = _a.weight, weight = _c === void 0 ? 'base' : _c, color = _a.color, rest = __rest(_a, ["size", "weight", "color"]);
    return (React.createElement(InternalProvider, null,
        React.createElement(TextElement, __assign({ fontSize: size, fontWeight: weight, ref: fRef, color: color }, rest))));
});
Text.displayName = 'Text';
var templateObject_1;
